import { render, staticRenderFns } from "./ModalProgramarTerapia.vue?vue&type=template&id=bc918062"
import script from "./ModalProgramarTerapia.vue?vue&type=script&lang=js"
export * from "./ModalProgramarTerapia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports